import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { createCompositeCarouselBlocks } from "../elements/equal-width-items.js";
import { buttonColorsOnWhite } from "../elements/nav-button.js";
import "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import "@universityofmaryland/web-utilities-library/events";
const createCompositeCarouselDefault = (props) => (() => {
  const {
    slide,
    shadowRef,
    blocks,
    isThemeDark,
    gridGap,
    hasLeftButton = true,
    hasRightButton = true,
    mobileHint = true,
    hint = true,
    tabletSize,
    desktopSize,
    tabletCount,
    desktopCount,
    maxCount,
    button
  } = props;
  let tabletBreakpoint = tabletSize ?? token.media.breakpointValues.desktop.min;
  let desktopBreakpoint = desktopSize;
  let blockGap;
  if (gridGap) {
    blockGap = parseInt(gridGap);
    tabletBreakpoint = 1e3 + parseInt(gridGap);
    desktopBreakpoint = 1400 + parseInt(gridGap);
  }
  const carouselContainer = createCompositeCarouselBlocks.CreateElement({
    slide,
    shadowRef,
    blocks,
    hasLeftButton,
    hasRightButton,
    showMobileHint: mobileHint,
    showHint: hint,
    tabletBreakpoint,
    desktopBreakpoint,
    tabletCount,
    desktopCount,
    maxCount,
    blockGap,
    button: {
      ...button,
      ...buttonColorsOnWhite(isThemeDark)
    }
  });
  const containerModel = new ElementBuilder().withClassName("element-carousel-default-container").withStyles({
    element: {
      position: "relative",
      overflow: "hidden"
    }
  }).withModifier((element) => {
    if (isThemeDark) {
      element.setAttribute("data-theme", "dark");
    }
  }).withChild(carouselContainer).build();
  const declarationModel = new ElementBuilder().withClassName("carousel-default-declaration").withStyles({
    element: {
      containerType: "inline-size",
      "& *": { color: token.color.white }
    }
  }).withChild(containerModel).withEvents({
    resize: carouselContainer.events.resize,
    load: carouselContainer.events.load
  }).build();
  return declarationModel;
})();
export {
  createCompositeCarouselDefault
};
//# sourceMappingURL=index.js.map
